// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,
  GameTypeTab,
  StatsGraph,
  AllGametypeTab
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import styles                 from './style';
import { Spinner } from 'react-activity';
import ReactTable from "react-table"; 
import moment from "moment";
import DatePicker from 'react-datepicker';
import Card from '../../../components/card/Card';
import styled from 'styled-components';
import ActiveCustomers from '../../partner/activeCustomers';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class CustomerDetails extends PureComponent {  

  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      customer_data: [],
      customer_headers: [],
      active_cust_count: 0,
      customer_details: true,
      paid_customer: false,
      excel_data:[],
      report_no:7537,
      report_name:'All Active Customers'

    };
    this.handleSelection = this.handleSelection.bind(this);
    this.onCustomerClick = this.onCustomerClick.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
    this.onPaidCustomerClick = this.onPaidCustomerClick.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

  componentDidMount() {
    this.getStats()
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    // $('.avtive_customers').find("a").trigger("click");
    // $('.monthly_revenue').find("a").trigger("click");
    if(!this.state.section){
      this.setState({section:'ActiveCustomer'});
    }
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }


  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getCustomers()
      this.getStats()   
    })
  }

  getStats() {
    const url = `${getLocationOrigin()}/cm/get_dashboard_stats/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({active_cust_count:data.active_cust})
           // alert("fix");
       }).catch(error => error);
  }

  getCustomers() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=${this.state.report_no}&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,customer_headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name;
    if(name == 'pay_n_play'){
      this.setState({report_no:75371,report_name:'Active Customers - Pay and Play'},()=>{this.getCustomers()});
    }
    else if(name == 'renewal'){
      this.setState({report_no:75372,report_name:'Active Customers - Renewals'},()=>{this.getCustomers()});
    }
    else if(name == 'all_customers'){
      this.setState({report_no:7537,report_name:'All Active Customers'},()=>{this.getCustomers()});
    }
    else{
      this.setState({report_no:75373,report_name:'New Active Customers'},()=>{this.getCustomers()});
    }
  }

  renderCustomers(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.customer_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.customer_headers.length; i++) {
        if(this.state.customer_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.customer_headers[i]);
          tab_index.push(i);
        }
      }
    }
    if(this.state.customer_data.length == 0 && headers.length == 0){
      this.getCustomers()
    }
    
    return(
      <div>

      <div style={{fontSize:'96%'}}>
          <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 7537 ? '#4daa0b':'#d7d9db'}} name='all_customers' onClick={this.handleSelection}> Active Customers </button>
          <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 75371 ? '#4daa0b':'#d7d9db'}} name='pay_n_play' onClick={this.handleSelection}> Pay and Play </button>
          <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 75372 ? '#4daa0b':'#d7d9db'}} name='renewal' onClick={this.handleSelection}> Renewals </button>
          <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 75373 ? '#4daa0b':'#d7d9db'}} name='new_customers' onClick={this.handleSelection}> New Customers</button>

        
      </div>

      <div style={{float:'right',marginTop:'2%'}}>
          {localStorage.getItem('access') == 'Trespasser' || localStorage.getItem('access') == 'Partner'?

            <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button"
                        table="table-to"
                        filename="Active Customers"
                        sheet="Active Customers"
                        buttonText="Download as XLS"/>
            :
            ''
          }
        </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>{this.state.report_name}</div> 
        <table className="table_plain">
          <tr> 
            {headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.customer_data && this.state.customer_data.length > 0 ?
              this.state.customer_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.customer_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      <table id="table-to" style={{opacity:'0',height:'10%'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
          
      </table>
      </div>
      )
  }

  

  onCustomerClick(){
    this.setState({customer_details:true,paid_customer:false})
  }

  onPaidCustomerClick(){
    this.setState({paid_customer:true,customer_details:false})
  }


  numberWithCommas(x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x.toLocaleString('en-IN');
  }
  

  render() {
    console.log('CustomerDetails props',this.props)

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    console.log('customer_data',this.state.customer_data)
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const cust_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const book_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const rev_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    console.log(this.state)

    return(
      <div >
        <div className='col-md-12'>
          {this.state.customer_details  &&
            this.renderCustomers()
          }

        </div>  

      </div>
    );
  }
}

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/customerDetails/CustomerDetails.js